const config = {
    BASE_URL: "https://websitebackend51.infoxtechnologies.com"

};

export default config;
